import React, { useState } from 'react';
import AdminUserManagement from './AdminUserManagement';
import AdminPanel from './AdminPanel';
import PendingOrdersTab from './PendingOrdersTab';
import AnalyticsTab from './AnalyticsTab';
import BotLogsTab from './BotLogsTab';

function AdminPanelWithTabs({ user, adminToken, jwtToken }) {
  const [activeSubTab, setActiveSubTab] = useState('users');

  return (
    <div className="admin-panel-container" style={{
      background: 'linear-gradient(to bottom right, #1e1b4b, #581c87, #1e293b)',
      minHeight: '100vh',
      padding: '2rem',
      borderRadius: '0.5rem'
    }}>
      {/* Sub-Tab Navigation */}
      <div style={{
        display: 'flex',
        gap: '1rem',
        marginBottom: '2rem',
        borderBottom: '1px solid rgba(168, 85, 247, 0.3)',
        paddingBottom: '1rem',
        flexWrap: 'wrap'
      }}>
        {/* Users Tab - DIFFERENT COLOR (Orange/Highlight) */}
        <button
          onClick={() => setActiveSubTab('users')}
          style={{
            padding: '0.75rem 1.5rem',
            background: activeSubTab === 'users' ? 'rgba(249, 115, 22, 0.6)' : 'transparent',
            border: `2px solid ${activeSubTab === 'users' ? '#f97316' : 'rgba(249, 115, 22, 0.3)'}`,
            color: '#fff',
            borderRadius: '0.5rem',
            cursor: 'pointer',
            fontWeight: 'bold',
            transition: 'all 0.3s',
          }}
        >
          👤 Users
        </button>

        {/* Vouchers, Newsletter, Orders - STANDARD COLOR (Purple) */}
        <button
          onClick={() => setActiveSubTab('vouchers')}
          style={{
            padding: '0.75rem 1.5rem',
            background: activeSubTab === 'vouchers' ? 'rgba(168, 85, 247, 0.5)' : 'transparent',
            border: `2px solid ${activeSubTab === 'vouchers' ? '#a855f7' : 'rgba(168, 85, 247, 0.3)'}`,
            color: '#fff',
            borderRadius: '0.5rem',
            cursor: 'pointer',
            fontWeight: 'bold',
            transition: 'all 0.3s',
          }}
        >
          🎟️ Vouchers
        </button>

        <button
          onClick={() => setActiveSubTab('newsletter')}
          style={{
            padding: '0.75rem 1.5rem',
            background: activeSubTab === 'newsletter' ? 'rgba(168, 85, 247, 0.5)' : 'transparent',
            border: `2px solid ${activeSubTab === 'newsletter' ? '#a855f7' : 'rgba(168, 85, 247, 0.3)'}`,
            color: '#fff',
            borderRadius: '0.5rem',
            cursor: 'pointer',
            fontWeight: 'bold',
            transition: 'all 0.3s',
          }}
        >
          📧 Newsletter
        </button>

        <button
          onClick={() => setActiveSubTab('orders')}
          style={{
            padding: '0.75rem 1.5rem',
            background: activeSubTab === 'orders' ? 'rgba(168, 85, 247, 0.5)' : 'transparent',
            border: `2px solid ${activeSubTab === 'orders' ? '#a855f7' : 'rgba(168, 85, 247, 0.3)'}`,
            color: '#fff',
            borderRadius: '0.5rem',
            cursor: 'pointer',
            fontWeight: 'bold',
            transition: 'all 0.3s',
          }}
        >
          📦 Pending Orders
        </button>

        <button
          onClick={() => setActiveSubTab('analytics')}
          style={{
            padding: '0.75rem 1.5rem',
            background: activeSubTab === 'analytics' ? 'rgba(168, 85, 247, 0.5)' : 'transparent',
            border: `2px solid ${activeSubTab === 'analytics' ? '#a855f7' : 'rgba(168, 85, 247, 0.3)'}`,
            color: '#fff',
            borderRadius: '0.5rem',
            cursor: 'pointer',
            fontWeight: 'bold',
            transition: 'all 0.3s',
          }}
        >
          📊 Analyse
        </button>

        <button
          onClick={() => setActiveSubTab('botlogs')}
          style={{
            padding: '0.75rem 1.5rem',
            background: activeSubTab === 'botlogs' ? 'rgba(168, 85, 247, 0.5)' : 'transparent',
            border: `2px solid ${activeSubTab === 'botlogs' ? '#a855f7' : 'rgba(168, 85, 247, 0.3)'}`,
            color: '#fff',
            borderRadius: '0.5rem',
            cursor: 'pointer',
            fontWeight: 'bold',
            transition: 'all 0.3s',
          }}
        >
          🤖 Bot-Logs
        </button>
      </div>

      {/* Sub-Tab Content */}
      <div style={{
        background: 'rgba(15, 23, 42, 0.5)',
        border: '1px solid rgba(168, 85, 247, 0.3)',
        borderRadius: '0.5rem',
        padding: '1.5rem'
      }}>
        {/* Users Tab */}
        {activeSubTab === 'users' && (
          <div>
            <h3 style={{ color: '#fff', marginBottom: '1rem', fontSize: '1.25rem' }}>👤 User Management</h3>
            <AdminUserManagement 
              adminToken={adminToken}
              userJWT={jwtToken}
            />
          </div>
        )}

        {/* Vouchers Tab */}
        {activeSubTab === 'vouchers' && (
          <div>
            <h3 style={{ color: '#fff', marginBottom: '1rem', fontSize: '1.25rem' }}>🎟️ Vouchers & Discounts</h3>
            <AdminPanel user={user} mode="vouchers" />
          </div>
        )}

        {/* Newsletter Tab */}
        {activeSubTab === 'newsletter' && (
          <div>
            <h3 style={{ color: '#fff', marginBottom: '1rem', fontSize: '1.25rem' }}>📧 Newsletter Management</h3>
            <AdminPanel user={user} mode="newsletter" />
          </div>
        )}

        {/* Pending Orders Tab */}
        {activeSubTab === 'orders' && (
          <div>
            <h3 style={{ color: '#fff', marginBottom: '1rem', fontSize: '1.25rem' }}>📦 Ausstehende Bestellungen</h3>
            <PendingOrdersTab adminToken={adminToken} />
          </div>
        )}

        {/* Analytics Tab */}
        {activeSubTab === 'analytics' && (
          <AnalyticsTab adminToken={adminToken} />
        )}

        {/* Bot Logs Tab */}
        {activeSubTab === 'botlogs' && (
          <BotLogsTab adminToken={adminToken} />
        )}
      </div>
    </div>
  );
}

export default AdminPanelWithTabs;
